import React from 'react';
import Card from 'react-bootstrap/Card';
import './CategoryCard.css';

function CategoryCard({ title, iconClass }) {
  return (
    <Card className='h-100 text-center category_card'>
      <div className="icon-wrapper">
        <i className={iconClass} style={{ fontSize: '4rem' }}></i>
      </div>
      <Card.Body>
        <Card.Title className='cat-card-title'>{title}</Card.Title>
      </Card.Body>
    </Card>
  );
}

export default CategoryCard;